import { CheckCircle, ArrowRight } from "lucide-react";
import {  useEffect } from "react";
import Logo from "./Logo";
import { ONBOARDING_CONSTANTS } from "../constant/constant"; // Correct import path

export default function ThankYouPage(
  {
  formData
}) {
  const {
    THANK_YOU_TITLE,
    THANK_YOU_DESCRIPTION,
    NEXT_STEPS_HEADING,
    NEXT_STEP_1_TEXT,
    NEXT_STEP_2_TEXT,
    NEXT_STEP_3_TEXT,
    BUTTON_TEXT,
    DASHBOARD_URL,
  } = ONBOARDING_CONSTANTS;
    // useEffect to perform validation whenever the formData changes
    useEffect(() => {
      // const { businessName  } = formData;
     
    }, [formData]);

  // Function to handle the button click and redirect
  const handleGoToDashboard_old = () => {
    // Check if the current window is an iframe by comparing it to its parent
    const isIframe = window.self !== window.parent;

    if (isIframe) {
      // If inside an iframe, open the URL in the top-level parent window.
      // This is the standard way to "break out" of an iframe to prevent embedding issues.
      console.log('in iframe');
      window.top.open(DASHBOARD_URL, "_blank");
    } else {
      console.log('outside iframe');
      // If not in an iframe, open the URL in a new tab as usual.
      window.open(DASHBOARD_URL, "_blank");
    }
  };

   const handleGoToDashboard = () => {
  // Check if the current window is an iframe
  const isIframe = window.self !== window.parent;

  if (isIframe) {
    //console.log('inside iframe, creating anchor');
    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = DASHBOARD_URL;
    a.target = "_blank";

    // Add security fixes for cross-site navigation
    a.rel = "noopener noreferrer";

    // Append it to the body (not strictly necessary but good practice)
    document.body.appendChild(a);

    // Programmatically click the anchor
    a.click();

    // Clean up the temporary element
    document.body.removeChild(a);

  } else {
    //console.log('outside iframe');
    // If not in an iframe, open the URL in a new tab as usual.
    window.open(DASHBOARD_URL, "_blank");
  }
};

  return (
    <div className="min-h-screen flex items-start justify-center pt-1 p-4" style={{ backgroundColor: '#ffffff' }}>
      <div className="bg-white rounded-2xl   p-8 w-full max-w-md">
        {/* Logo at the top, consistent with other steps */}
        <Logo />

        {/* Main Content Area */}
        <div className="flex flex-col items-center text-center space-y-4 mt-8">
          <CheckCircle size={64} className="text-green-500" />
          <h2 className="text-2xl font-semibold text-gray-900">
            {THANK_YOU_TITLE}
          </h2>
          <p className="text-gray-600">
            {THANK_YOU_DESCRIPTION} for {formData.businessName}
          </p>
          <div className="w-full text-left mt-6">
            <h3 className="font-semibold text-gray-800 mb-3">
              {NEXT_STEPS_HEADING}
            </h3>
            <ol className="list-decimal list-inside space-y-2 text-sm text-gray-600">
              <li>{NEXT_STEP_1_TEXT}</li>
              <li>{NEXT_STEP_2_TEXT}</li>
              <li>{NEXT_STEP_3_TEXT}</li>
            </ol>
          </div>
        </div>

        {/* Action Button at the bottom */}
        <button
          onClick={handleGoToDashboard}
          className="w-full py-4 bg-gradient-to-r from-green-500 to-teal-600 text-white rounded-lg hover:from-green-600 hover:to-teal-700 transition-all flex items-center justify-center space-x-2 mt-6"
        >
          <span>{BUTTON_TEXT}</span>
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}